"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraOffState = require("./CameraOffState");
Object.keys(_CameraOffState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraOffState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraOffState[key];
    }
  });
});